import * as React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import "./FormDialog.css";
import Button from "../Button/Button";
import close from '../../assets/icons/close.svg';
import { Tooltip } from '@mui/material';

export default function ConfirmationDialog({ 
  open, 
  handleClose, 
  title, 
  message, 
  onConfirm, 
  onCancel,
  confirmText = "Continue",
  cancelText = "Cancel"
}) {
  
  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    handleClose();
  };

  return (
    <div>
      <Dialog className='custom-dialog' open={open} onClose={handleClose}>
        <DialogTitle className="title-dialog">
          {title}
          <Tooltip title='Close' arrow placement='bottom'>
            <img
              tabIndex={0}
              src={close}
              onClick={handleClose}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  handleClose();
                }
              }}
              alt='close'
              style={{ cursor: "pointer" }}
            />
          </Tooltip>
        </DialogTitle>
        <DialogContent className='content-dialog'>
          <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
            {message}
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            className="cancel button-popup"
            text={cancelText}
            onClick={handleCancel}
            heading={cancelText}
          />
          <Button
            className="create button-popup"
            text={confirmText}
            onClick={handleConfirm}
            heading={confirmText}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}
